export enum LorenContentTypes {
    BLOB = "blob",
    EXCEL = "xlsx",
    PDF = "pdf",
}
